import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import { useParams } from "react-router-dom";
import { DateFormat } from '../../../hooks/dateFormat'
import { CONSTANTS } from '../../../constants';

const toStartOfDay = (date) => {
    const newDate = new Date(date)
    newDate.setHours(0)
    newDate.setMinutes(0)
    newDate.setSeconds(0)
    newDate.setMilliseconds(0)
    return newDate
}
const findEventsForDate = (events, date) => {
    const dateTime = date.getTime()
    return events.filter(event => {
        const eventFromTime = toStartOfDay(event.from).getTime()
        const eventToTime = toStartOfDay(event.to).getTime()
        return (dateTime >= eventFromTime && dateTime <= eventToTime)
    })
}

const MiniEvent = ({ event, setViewingEvent }) => {
    const {CURRENCY} = CONSTANTS;
    
    
    return (
        <div
            style={{opacity:(event.id)?'1':'0.7'}}
            className={`miniEvent ${event.type ? event.type.toLowerCase() : "standard"}`}
            onClick={() => setViewingEvent(event)}>
            {event.name}: {(event.type === 'cost_per_click' || event.type === 'cost_per_view')?`${CURRENCY}${event.value}`:event.value}
        </div>
    )
}

const Grid = (props) => {
    const { date, events, setViewingEvent, setShowingEventForm, actualDate } = props;
    const ROWS_COUNT = 6
    const currentDate = toStartOfDay(new Date())
    const [dates, setDates] = React.useState([]);
    const { userId } = useParams();
  
    React.useEffect(() => {
        const startingDate = new Date(date.getFullYear(), date.getMonth(), 1)
        startingDate.setDate(startingDate.getDate() - (startingDate.getDay() - 1))
        const datesArray = []
        for (let i = 0; i < (ROWS_COUNT * 7); i++) {
            const date = new Date(startingDate)
            datesArray.push({ date, events: findEventsForDate(events, date) })
            startingDate.setDate(startingDate.getDate() + 1)
        }
        setDates(datesArray);
    }, [date,events]);

   

    

    React.useEffect(() => {
        const startingDate = new Date(date.getFullYear(), date.getMonth(), 1);
        startingDate.setDate(startingDate.getDate() - (startingDate.getDay() - 1));
        const startDate = DateFormat(startingDate,'YYYY-MM-DD');
        const endDate = DateFormat(new Date(startingDate.getTime() + (ROWS_COUNT * 7) * 24 * 60 * 60 * 1000),'YYYY-MM-DD');
        props.getCampaignSetting({start_date:startDate, end_date:endDate,user_id:userId});
    },[date,props.campaignSettingSaved, props.campaignSettingDeleted]);
    
    return (
        <Fragment>
            {dates.map((date, index) => {
                return (
                    <div
                        key={index}
                        className={`cell ${date.date.getTime() === currentDate.getTime() ? "current" : ""} ${date.date.getMonth() !== actualDate.getMonth() ? "otherMonth" : ""}`
                        }>
                        <div className="date">
                            {date.date.getDate()}
                            {((date.events).length < 4 && (date.date.getTime() >= currentDate.getTime())) ? <button className="addEventOnDay" onClick={() => setShowingEventForm({ visible: true, preselectedDate: date.date, dateEvents: date.events })}>+</button>:''}
                        </div>
                        {date.events.map((event, index) =>
                            <MiniEvent key={index} event={event} setViewingEvent={setViewingEvent} />
                        )}
                    </div>
                )
            })}
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaignSettingsList: (state.campaign && state.campaign.campaignSettingsList && state.campaign.campaignSettingsList.data) ? state.campaign.campaignSettingsList.data : [],
    campaignSettingSaved: (state.campaign && state.campaign.campaignSettingSaved) ? state.campaign.campaignSettingSaved : null,
    campaignSettingDeleted: (state.campaign && state.campaign.campaignSettingDeleted) ? state.campaign.campaignSettingDeleted : null,
});
const mapDispatchToProps = (dispatch) => ({
    getCampaignSetting: (payload) => dispatch(CampaignAction.getCampaignSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Grid);

